<template>
  <div class="nav-account">
    <div v-if="!login" class="notlogin">
      <!-- <a class="nav-account-login" @click="loginHandler()">登录</a>
      <a class="nav-account-reg"  @click="trialHandler()">试用</a> -->

      <loginDialog
        :dialogVisible="dialogVisible"
        :toTab="toTab"
        :mode="mode"
        @onCancel="onCancel"
        :title="dialogTitle"
      ></loginDialog>
    </div>
    <div class="login-box" v-if="login">
      <el-dropdown placement="bottom-end" @command="logoutHandler">
        <span class="el-dropdown-link">
          <i class="iconfont icondingbudaohang-zhangh"></i>
          <span class="mobile" v-html="info.mobile"></span>
          <i class="iconfont iconxiala"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import loginDialog from '@/components/dialog/login-dialog'
export default {
  components: { loginDialog },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      login: false,
      toTab: 1,
      mode: 'c',
      info: {},
    }
  },
  computed: {
    loginStatus() {
      return this.$store.state.app.login //需要监听的数据
    },
  },
  watch: {
    loginStatus(newVal, oldVal) {
      this.login = newVal
      this.judgeLogin()
    },
  },
  created() {
    this.$bus.on('checkUserLogin', this.checkUserLogin)
  },
  mounted() {
    this.login = this.$store.state.app.login
    this.judgeLogin()
  },
  methods: {
    checkUserLogin() {
      this.loginHandler()
    },
    trialHandler() {
      this.toTab = 2
      this.dialogVisible = true
    },
    loginHandler() {
      this.toTab = 1
      this.dialogVisible = true
    },
    logoutHandler() {
      this.$store.dispatch('setLogin', false)
      this.$cookies.remove('client_token')
      this.$cookies.remove('hr_token')
      this.$axios.defaults.headers.common['authorization'] = null
      this.$message.success('退出成功！')
    },
    judgeLogin() {
      let token = this.$cookies.get('client_token')
      if (token) {
        this.info = token
        this.$axios.defaults.headers.common['authorization'] = token.token
        this.$store.dispatch('setLogin', true)
      } else {
        this.$store.dispatch('setLogin', false)
      }
    },
    onCancel() {
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-account {
  color: #666;
  line-height: 24px;
  float: right;
  padding: 2px 0;
  margin: 15px 10px 0 10px;
  white-space: nowrap;
  .notlogin {
    width: 143px;
    display: block;
  }
  .login-box {
    min-width: 143px;
    line-height: 24px;
    cursor: pointer;
    i {
      font-size: 24px;
      &.iconjiantou {
        font-size: 24px;
        position: relative;
      }
    }
    .mobile {
      font-size: 12px;
      position: relative;
      top: -4px;
    }
  }
  a {
    cursor: pointer;
  }
  .nav-account-login {
    padding: 0 3px 0 20px;
    color: #29bdb9;
  }

  .nav-account-reg {
    padding: 4px 15px;
    background: rgb(41, 189, 185);
    border-radius: 20px;
  }

  a {
    display: inline-block;
    color: #fff;
    font-size: 14px;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/login/to-c.vue